import Vue from 'vue';
import Vuex from 'vuex';
import App from './src/updates-and-news/App.vue';
import { BlueSearch, store } from '@bluemodus/blue-search';

import '@bluemodus/blue-search/dist/style.css';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#updates-and-news');
  const options = { ...el.dataset };

  Vue.config.productionTip = false;
  Vue.use(BlueSearch, options);
  Vue.use(Vuex);

  new Vue({
    store: new Vuex.Store(store),
    render: h => h(App),
  }).$mount(el);
});
